import { motion } from "framer-motion";

import "./style.css";
import { fadeInUp } from "../../../animations/fadeVariants";
const ExperienceItem = ({ beginYear, endYear, title }) => {
  return (
    <motion.div {...fadeInUp}>
      <div className="exp-card-wrapper">
        <div className="exp-time">
          <span>{beginYear}</span>
          {endYear !== 0 && (
            <>
              <span>-</span>
              <span>{endYear}</span>
            </>
          )}
        </div>
        <h1 className="exp-title">{title}</h1>
      </div>
    </motion.div>
  );
};

export default ExperienceItem;
